"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIX_STORES_DOMAIN_NAMES = exports.SUPPORTS_ONLY_STORES_V3_TAG_ID = exports.SUPPORTS_BOTH_STORES_V1_V3_TAG_ID = exports.IS_APP_ALREADY_INSTALLED = exports.APP_PERMISSIONS = exports.INSTALLATION_SOURCE_TOKEN = exports.GET_APP_INSTALLATION_DATA = exports.GET_IDENTITY_TOKEN_VALIDATION = exports.GET_INSTALLER_TOPOLOGY = exports.APP_INSTALLER_SCOPE = exports.OAUTH_PROXY = void 0;
exports.OAUTH_PROXY = '/oauthProxy';
exports.APP_INSTALLER_SCOPE = 'app-installer';
exports.GET_INSTALLER_TOPOLOGY = '/getInstallerTopology';
exports.GET_IDENTITY_TOKEN_VALIDATION = '/getIdentityTokenValidation';
exports.GET_APP_INSTALLATION_DATA = '/getAppInstallationData';
exports.INSTALLATION_SOURCE_TOKEN = '/installationSourceToken';
exports.APP_PERMISSIONS = '/app-permissions';
exports.IS_APP_ALREADY_INSTALLED = '/isAppAlreadyInstalled';
exports.SUPPORTS_BOTH_STORES_V1_V3_TAG_ID = 'fe14d8f2-b9a0-4358-9cd7-d4e5ac62cb5b';
exports.SUPPORTS_ONLY_STORES_V3_TAG_ID = '0298ed69-4338-4d55-95ba-bcf3eef4c6d9';
exports.WIX_STORES_DOMAIN_NAMES = ['wix stores', 'stores'];
//# sourceMappingURL=consts.js.map